import { TweenLite, TimelineLite, TimelineMax, Power0, Expo, Power3 } from 'gsap'
import flickityHelpers from '../util/flickityHelpers'
import BreakpointHelpers from '../util/breakpointHelpers'
import AnimatedComponent from './AnimatedComponent'
const Flickity = require('flickity')

class Slider extends AnimatedComponent {
  constructor ($el) {
    super($el, { delay: 0.2 })
    this.bpHelpers = new BreakpointHelpers()
    this.$navigation = $el.find('.slider__nav')
    this.flkty = null
    this.index = 0
    this.isAnimating = false
    this.slidesCount = $el.find('.image').length
    this.timeline = null
    this.shouldAutoplay = this.$el.data('autoplay')
    this.isPaused = false

    if (!this.$el.hasModifier('single-image')) {
      this.initSlider()
    }

    this.$el.find('a').each((i, a) => {
      const $a = $(a)
      const $hover = $a.find('.hover')
      const timeline = new TimelineMax({ paused: true })
      timeline
        .set(
          $hover,
          { autoAlpha: 1 }
        )
        .fromTo(
          $hover.find('.cover'),
          0.4,
          { opacity: 0 },
          {
            opacity: 1,
            ease: Power0.easeNone,
          },
          0
        )
        .staggerFromTo(
          $hover.find('.meta').children(),
          0.4,
          {
            y: '20px',
            autoAlpha: 0,
          },
          {
            y: '0px',
            autoAlpha: 1,
            ease: Power3.easeInOut,
          },
          0.1,
          0.05
        )

      $a.hover(
        () => {
          this.isPaused = true
          timeline.play()
        },
        () => {
          this.isPaused = false
          timeline.reverse()
        }
      )
    })

    if (!this.shouldAutoplay) {
      return
    }

    this.$navigation.hover(
      () => {
        this.isPaused = true
      },
      () => {
        this.isPaused = false
      }
    )

    this.timelineIn.eventCallback('onComplete', () => {
      this.autoplayInterval = setInterval(() => {
        if (this.isPaused) {
          return
        }
        const index = this.index + 1 <= this.slidesCount - 1 ? this.index + 1 : 0
        this.select(index)
      }, 5000)
    })
  }

  buildTimelineIn () {
    const $el = this.$el
    this.timelineIn
      .fromTo(
        $el.find('.image').first(),
        1.2,
        { x: '-100%' },
        { x: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        $el.find('.image').first().find('.bg'),
        1.2,
        { x: '100%' },
        { x: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        $el.find('.image').first().find('.bg'),
        0.5,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0
      )

    if ($el.find('.scroll-down').length > 0) {
      this.timelineIn
        .fromTo(
          $el.find('.scroll-down'),
          0.4,
          { autoAlpha: 0 },
          { autoAlpha: 1, ease: Power0.easeNone }
        )
    }
  }

  select (index) {
    if (!this.timeline) {
      return
    }

    const $currentImage = this.$el.find('.image.active')
    const $nextImage = this.$el.find('.image').eq(index)
    this.isAnimating = true
    this.timeline.timeScale(0.9)
    this.timeline
      .clear()
      .fromTo($currentImage, 1.2, { x: '0%' }, { x: '-100%', ease: Expo.easeInOut }, 0)
      .fromTo($currentImage.find('.bg'), 1.2, { x: '0%' }, { x: '80%', ease: Expo.easeInOut }, 0)
      .fromTo($nextImage, 1.2, { x: '100%' }, { x: '0%', ease: Expo.easeInOut }, 0)
      .fromTo($nextImage.find('.bg'), 1.2, { x: '-80%' }, { x: '0%', ease: Expo.easeInOut }, 0)

    $currentImage
      .add($nextImage)
      .toggleClass('active')

    this.index = index
  }

  initFlickity () {
    const flkty = new Flickity(this.$el.find('.slider__slides').get(0), {
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false,
    })

    $(flkty.element).on('scroll.flickity', (event, progress) => {
      flkty.slides.forEach((slide, i) => {
        let x = flickityHelpers.getX(slide, i, flkty)
        x *= -1 / 1.2
        TweenLite.set($(slide.cells[0].element).find('.bg'), { x: `${x}px` })
      })
    })

    flkty.on('select', () => {
      this.$navigation
        .find('li')
        .removeClass('active')
        .eq(flkty.selectedIndex)
        .addClass('active')
    })

    this.flkty = flkty
  }

  initSlider () {
    if (!this.bpHelpers.isScreenAtLeast('xl')) {
      this.initFlickity()
    } else {
      this.timeline = new TimelineLite({
        onComplete: () => {
          this.isAnimating = false
        },
      })
    }

    this.$navigation.on('click', 'li', (event) => {
      if (this.isAnimating) {
        return
      }
      const $bullet = $(event.target)
      if ($bullet.hasClass('active')) {
        return
      }
      this.$navigation.find('li.active').add($bullet).toggleClass('active')
      const index = this.$navigation.find('li').index(event.target)
      if (this.flkty) {
        this.flkty.select(index)
      } else {
        this.select(index)
      }
    })
  }
}

export default Slider



// WEBPACK FOOTER //
// ./scripts/components/Slider.js